import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CallCancelFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="m8.71 14.09 1.1-1.1.99-.99c-.92-1.19-.98-1.76-.95-1.96.02-.18.15-.28.4-.45.09-.06.17-.12.24-.17l.55-.48c1.56-1.36.41-3.15.04-3.73l-.4-.63c-.43-.67-1.03-1.44-1.87-1.57-.51-.07-1 .1-1.47.5l-.45.4c-.53.38-1.79 1.5-2.1 3.54-.35 2.3.66 4.86 2.95 7.62l.98-.98h-.01ZM19.21 14.4l-.56-.48c-.53-.45-2.14-1.84-3.71-.48l-.55.48c-.06.05-.13.13-.21.21-.2.22-.31.33-.5.33-.17 0-.56-.1-1.27-.71l5.77-5.77c.3-.3.3-.78 0-1.07-.3-.3-.78-.3-1.07 0L5.3 18.71c-.3.3-.3.78 0 1.07.15.15.34.22.54.22s.39-.07.54-.22l2.97-2.97c2.08 1.99 4.13 3.02 6.14 3.02h.07c2.07-.02 3.35-1.11 3.76-1.54l.5-.43c.47-.41.7-.87.7-1.38 0-.86-.69-1.56-1.29-2.07l-.02-.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CallCancelFilled
